import module from 'nominas/finiquito/module.js'
import template from './template.html'

export class NominasFiniquitoNominaEliminarComponent {
  data
  onClose
  confirmarIdNomina = ''
  resultado = null
  procesando = false

  constructor (NominasFiniquitoIdnomina) {
    this.NominasFiniquitoIdnomina = NominasFiniquitoIdnomina
  }

  aceptar () {
    if (this.procesando) return

    if (this.confirmarIdNomina.toUpperCase() !== this.data.nomina.id.toUpperCase()) {
      this.error = true

      return
    }

    this.procesando = true

    this.NominasFiniquitoIdnomina.delete(this.data.proyecto.id, this.data.colaborador.id, this.data.finiquito.id)
      .then((response) => (this.cerrar(response.data)))
      .finally(() => (this.procesando = false))
  }

  cerrar (data) {
    this.onClose({$event: {data: data}})
  }
}

module.component('nominasFiniquitoNominaEliminar', {
  controller: NominasFiniquitoNominaEliminarComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/nomina/eliminar/component.js